export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14802.ef3f0c2f.jpg";